"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _MenuItemTypeCode = _interopRequireDefault(require("./MenuItemTypeCode"));
var _SamlLink = _interopRequireDefault(require("../../components/authn/SamlLink"));
var _Menu = _interopRequireDefault(require("../../api/Menu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const renderNavLink = (menuItem, isdd) => {
  if (menuItem.menuItemTypeCode === _MenuItemTypeCode.default.SAML_PROVIDER) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: `mli_${menuItem.id}`
    }, /*#__PURE__*/_react.default.createElement(_SamlLink.default, {
      title: menuItem.title,
      providerId: menuItem.icon,
      path: menuItem.path
    }));
  }
  return /*#__PURE__*/_react.default.createElement("li", {
    key: `mli_${menuItem.id}`
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: menuItem.path.includes('http') ? {
      pathname: `${menuItem.path}`
    } : menuItem.path,
    className: `${isdd !== undefined ? 'dropdown-item' : ''}`,
    activeClassName: "is-active",
    key: `mlc_${menuItem.id}`
  }, menuItem.title || menuItem.name));
};
const renderMenuItem = (menuItem, isdd) => renderNavLink(menuItem, isdd);
const MegaMenuLinks = _ref => {
  var _SecurityContextHolde;
  let {
    menuItems,
    toggleActive
  } = _ref;
  let menuItemList = [];
  if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu) {
    menuItemList = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().getMainMenuLinks();
  }
  if (menuItems && (!_SecurityContextHolder.SecurityContextHolder.isAuthenticated() || !((_SecurityContextHolde = _SecurityContextHolder.SecurityContextHolder.getCurrentContext()) !== null && _SecurityContextHolde !== void 0 && _SecurityContextHolde.menu))) {
    const menu = _Menu.default.from({
      menuItems
    });
    menuItemList = menu.getMainMenuLinks();
  } else if (menuItems && menuItems.length > 0) {
    menuItemList = menuItems;
  }
  const uniqueUrls = {};
  let uniqueMenuCount = 0;
  menuItemList.forEach(menuItem => {
    if (typeof menuItem.visible !== 'undefined' && menuItem.visible) {
      if (menuItem.path && !(menuItem.path in uniqueUrls)) {
        uniqueUrls[menuItem.path] = menuItem.path;
        uniqueMenuCount++;
      }
      if (menuItem.children) {
        menuItem.children.forEach(childMenuItem => {
          if (typeof childMenuItem.visible !== 'undefined' && childMenuItem.visible) {
            if (childMenuItem.path && !(childMenuItem.path in uniqueUrls)) {
              uniqueUrls[childMenuItem.path] = childMenuItem.path;
              uniqueMenuCount++;
            }
          }
        });
      }
    }
  });

  // If there is only one unique menuItem.path, don't display the menus since the navigation bar will look unbalanced
  if (uniqueMenuCount === 1) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
  return menuItemList.filter(menuItem => typeof menuItem.visible !== 'undefined' && menuItem.visible).map(menuItem => /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar-item",
    "aria-haspopup": "true",
    key: `mml_${menuItem.id}`,
    onMouseEnter: () => window.innerWidth >= 1024 ? toggleActive(true) : ''
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: menuItem.path,
    activeClassName: "is-active",
    className: "navbar-link",
    key: `ml_${menuItem.id}`
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, menuItem.icon), menuItem.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-content"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "menu-list"
  }, typeof menuItem.children !== 'undefined' && menuItem.children.filter(child => typeof child.visible !== 'undefined' && child.visible).map(child => renderMenuItem(child))))));
};
MegaMenuLinks.propTypes = {
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    children: _propTypes.default.array,
    description: _propTypes.default.string,
    icon: _propTypes.default.string,
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    image: _propTypes.default.string,
    imageAlt: _propTypes.default.string,
    path: _propTypes.default.string,
    title: _propTypes.default.string,
    visible: _propTypes.default.bool
  })),
  toggleActive: _propTypes.default.func
};
MegaMenuLinks.defaultProps = {
  menuItems: []
};
var _default = exports.default = MegaMenuLinks;
//# sourceMappingURL=MegaMenuLinks.js.map